<template>
  <Form 
    :d_form='form'
    :d_sumber_peruntukan='sumber_peruntukan'
    v-if="id > 0 && load == 2"
  /> 

  
  <Form 
    :d_form='form'
    :d_sumber_peruntukan='sumber_peruntukan'
    v-else-if="id == 0 && load == 1"
  /> 
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import Form from "./_From.vue";

export default {
  extends: ZResource,
  components: {
    Form
  },
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'tangki.perolehan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        // { label: 'Daftar Tangki LN2', route: '/tangki' },
        { label: 'Perolehan', route: '/tangki/perolehan' },
      ],
      title : 'Perolehan',
      form : {
        id : 0,
        tarikh : '',
        isipadu : '',
        harga : '',
        user_id : '',
        lkp_sumber_peruntukan_id : '',
        
      },
      tarikh : [],
      isipadu : [],
      harga : [],
      user_id : [],
      sumber_peruntukan : [],
      load : 0
      
      
    }
  },
  methods: {
    

 
    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'tangki_perolehan/show/'+this.id, {}).then(res => {
          this.form = res
          this.load = this.load + 1

        })
      }
    },
    
    getSumber(){
          this.load = this.load + 1
        this.$zcomm.get(this.api_service + 'lookup/sumber_peruntukan', {}).then(res => {      
          this.sumber_peruntukan = res
        })
    },
  
  },

  watch: {

  },
  mounted() {
    this.getSumber();
    this.getData()
    
  }
    
}
</script>
